export default __webpack_public_path__ + "b11fa191cc768f7efde8427996077c27.jpg";